import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import api from 'axios';
import memoize  from 'lodash/memoize';
const API_URI = 'https://www.homeimprovementpages.com.au/system/ajax_handlers/vtk.ac.search.category.and.site.server.json.php';
const BaseUrl = '';

export function highlightQuery(item, query) {
    const startPos = item.toLowerCase().indexOf(query.toLowerCase());
    if (startPos < 0) return <span>{item}</span>;
    const endPos = startPos + query.length;
    const start = item.slice(0, startPos);
    const middle = item.slice(startPos, endPos);
    const end = item.slice(endPos, item.length);
    return <span>{start}<span className="category-site-search__suggestion-highlight">{middle}</span>{end}</span>;
}

export function renderSuggestion(suggestion, { query }) {
    return (<div>
    {suggestion.thumbnail && <img src={suggestion.thumbnail} alt={suggestion.name} width={30} height={21} />}
    {highlightQuery(suggestion.name, query)}
    </div>);
}

export function getSuggestionValue(suggestion) {
    return suggestion.name;
}

export function onSuggestionSelected(event, { suggestion }) {
    if (suggestion.url) {
        // remove " and leading slashes from url
        window.location.href = `${BaseUrl}/${suggestion.url.replace(/"/g, '').replace(/^\/+/g, '')}`;
    }
}

const fetchSuggestions = memoize(query => api.get(API_URI, { params: { query } }));

export function makeTheme(prefix) {
    return {
        container: `${prefix}__container`,
        containerOpen: `${prefix}__container--open`,
        input: `${prefix}__input`,
        suggestionsContainer: `${prefix}__suggestions-container`,
        suggestionsList: `${prefix}__suggestions-list`,
        suggestion: `${prefix}__suggestion`,
        suggestionFocused: `${prefix}__suggestion--focused`,
        sectionContainer: `${prefix}__section-container`,
        sectionTitle: `${prefix}__section-title`
    };
}

export default class CategorySiteSearch extends Component {

    static propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        classPrefix: PropTypes.string,
        focusInputOnSuggestionClick: PropTypes.bool,
        fetchSuggestions: PropTypes.func.isRequired,
        id: PropTypes.string
    };

    static defaultProps = {
        focusInputOnSuggestionClick: true,
        value: '',
        onChange: f => f,
        fetchSuggestions
    };

    state = {
        suggestions: [],
        theme: {},
        value: ''
    };

    componentWillMount() {
        this.setState({
            theme: makeTheme(this.props.classPrefix),
            value: this.props.value
        });
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onChange = (event, { newValue }) => {
        this.setState({ value: newValue })
        this.props.onChange && this.props.onChange(newValue);
    };

    loadSuggestions = (query) => fetchSuggestions(query)
        .then(response => {
        this.setState({ suggestions: groupResults(response.data) });
    });

    render() {
        const { suggestions, theme } = this.state;
        const { value, id, classPrefix, renderInputComponent, focusInputOnSuggestionClick } = this.props;
        const inputProps = {
            placeholder: `I'm looking for... (e.g Plumber)`,
            name: 'search_str',
            value: value || this.state.value,
            onChange: this.onChange
    };

    return (
        <Autosuggest
        id={id}
        className={`${classPrefix}__container`}
        multiSection
        suggestions={suggestions}
        inputProps={inputProps}
        renderSuggestion={renderSuggestion}
        focusInputOnSuggestionClick={focusInputOnSuggestionClick}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        getSectionSuggestions={getSectionSuggestions}
        renderSectionTitle={renderSectionTitle}
        renderInputComponent={renderInputComponent}
        onSuggestionSelected={onSuggestionSelected}
        theme={theme}
        />
        );
    }

}

export function getSectionSuggestions(section) {
    return section.suggestions;
}

export function renderSectionTitle(section) {
    return (
        <strong>{section.title}</strong>
        );
}

export function groupResults(results, query) {
    const buckets = [
        { title: 'Categories', suggestions: [] },
        { title: 'Businesses', suggestions: [] }
    ];

    if (!Array.isArray(results)) return buckets;
    return trimResults(results.reduce(([categories, sites], item) => {
        item.query = query;
    if (item.id) {
        categories.suggestions.push(item);
    } else {
        sites.suggestions.push(item);
    }
    return buckets;
}, buckets)).filter(section => section.suggestions.length);
}

export function trimResults(results) {
    const MAX = 12;
    const SITE_MIN = 5;
    const [categories, sites] = results;
    const categoryCount = categories.suggestions.length;
    const siteLimit = Math.max(SITE_MIN, MAX - categoryCount);

    const limitedCategories = categories.suggestions.slice(0, MAX);
    const limitedSites = sites.suggestions.slice(0, siteLimit);

    return [
        { title: 'Categories', suggestions: limitedCategories },
        { title: 'Businesses', suggestions: limitedSites }
    ];
}

